<template>
  <div class="event-calender">
    <full-calendar :events="events" defaultView="month" :editable="false"
      @event-selected="eventClicked"></full-calendar>

  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['allEvents'],
  data() {
    return {
      events: [],
    }
  },
  mounted() {
    this.drawCalendar()
  },
  watch: {
    'allEvents'() {
      this.drawCalendar()
    }
  },
  methods: {
    drawCalendar() {
      Object.keys(this.allEvents).map((type) => {
        this.allEvents[type].map((event) => {
          this.events.push({
            title: event.title,
            id: event.id,
            start: event.start_date,
            end: moment(event.end_date, "YYYY-MM-DD").add(1, 'days'),
          })
        })
      })
    },
    eventClicked(args) {
      this.$router.push(`/event/${args.id}`)
    }
  }
}
</script>

<style scoped>
.fc-view-container .tr{
  background: #F8F8F8;
}

.fc-day-grid{
  background: #F8F8F8;
}

.event-calender{
  margin-bottom: 50px;
  padding: 0px 15px;
}

</style>
